import(/* webpackMode: "eager" */ "/app/main/app/[locale]/gallery/list/page.tsx");
